"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils/utils");
// Packages

// Utils

// Styles
const {
  below
} = (0, _utils.getMediaQueries)();
const SuperNavWrapper = _styledComponents.default.nav.withConfig({
  displayName: "super-nav__SuperNavWrapper",
  componentId: "sc-1wslewn-0"
})(["display:grid;grid-template-rows:auto 0;min-height:48px;max-width:1248px;padding:0px 48px;margin:0 auto;align-items:center;justify-content:flex-end;transition:0.3s ease-in-out;", " :after{}hr{height:1px;max-width:100%;width:662px;background:linear-gradient( 270deg,rgba(226,232,240,1) 0%,rgba(226,232,240,0) 100% );border-bottom:none;}"], below.tablet`display: none;`);
const NavItemsList = _styledComponents.default.ul.withConfig({
  displayName: "super-nav__NavItemsList",
  componentId: "sc-1wslewn-1"
})(["display:flex;gap:10px;justify-content:flex-end;li > *{color:var(--orca-grey-8-hex);display:flex;font-size:16px;line-height:20px;gap:10px;padding:12px 0 12px 12px;text-decoration:none;&:hover{text-decoration:none;color:var(--pacific-blue-hex);}}"]);
function SuperNav(props) {
  return /*#__PURE__*/_react.default.createElement(SuperNavWrapper, {
    className: props.className ? props.className : ""
  }, props.navItems && /*#__PURE__*/_react.default.createElement(NavItemsList, null, props.navItems.map((item, i) => {
    return item;
  })), /*#__PURE__*/_react.default.createElement("hr", null));
}
SuperNav.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SuperNav"
};
var _default = SuperNav;
exports.default = _default;